import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@/lib/api'

/**
 * Admin AI cost config — hard monthly cap (USD).
 *
 * Backed by `GET/PUT /api/admin/ai/cost/config` (see
 * `apps/api/src/routes/admin-ai-cost-config.routes.ts`). Response shape is
 * `{ monthly_cap_usd: number }`. A value of 0 means "disabled".
 */

export interface AICostConfig {
  monthly_cap_usd: number
}

export const aiCostConfigQueryKey = ['ai-cost-config'] as const

export function useAICostConfig() {
  return useQuery({
    queryKey: aiCostConfigQueryKey,
    queryFn: () => api.get<AICostConfig>('/admin/ai/cost/config'),
    staleTime: 60_000,
  })
}

export function useSaveAICostConfig() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (monthly_cap_usd: number) =>
      api.put<AICostConfig>('/admin/ai/cost/config', { monthly_cap_usd }),
    onSuccess: (data) => {
      qc.setQueryData(aiCostConfigQueryKey, data)
    },
  })
}
